import { HttpClient } from '@angular/common/http';
import { NgZone } from '@angular/core';
import { ConfigurationService } from '../configuration/configuration.service';
import { CmsPreviewModeService } from '../content/cms-preview-mode.service';
import { LoggerService } from '../logging/logger.service';
import { ServerVarsService } from '../server-vars/server-vars.service';
import { DeliveryCountryCookieService } from '../service/delivery-country-cookie.service';
import { PlatformService } from '../universal/platform.service';
import { ServerService } from '../universal/server.service';
import { BasicAuthService } from './basic-auth.service';
import { DefaultApiService } from './default-api.service';

export function apiServiceFactory(
    http: HttpClient,
    config: ConfigurationService,
    _urlSerializer: unknown,
    logger: LoggerService,
    basicAuth: BasicAuthService,
    serverVars: ServerVarsService,
    platform: PlatformService,
    ngZone: NgZone,
    deliveryCountryCookieService: DeliveryCountryCookieService,
    serverService: ServerService,
    previewMode: CmsPreviewModeService
) {
    return new DefaultApiService(
        http,
        config,
        logger,
        basicAuth,
        serverVars,
        platform,
        ngZone,
        deliveryCountryCookieService,
        serverService,
        previewMode
    );
}
